"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "InputField", {
  enumerable: true,
  get: function get() {
    return _InputField["default"];
  }
});
exports["default"] = void 0;

var _InputField = _interopRequireWildcard(require("../InputField"));

/**
 * DEPRECATED - only exists for backwards compatibility
 */
var _default = _InputField.Input;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/Form/Input.js
// module id = 492
// module chunks = 0